import {ActivatedRouteSnapshot, CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityService} from './security.service';
import {map} from 'rxjs/operators';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(private securityService: SecurityService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return this.securityService.hasPermission(route.data.expectedRole).
      pipe(map((allowed: boolean) => allowed));
  }

}
